import React, { useEffect, useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { PlusIcon, CalendarIcon, UsersIcon, PercentIcon, ClockIcon, MapPinIcon, BellIcon, UserPlusIcon, AlertTriangleIcon, CheckCircleIcon, EditIcon, StarIcon, TrendingUpIcon, TrendingDownIcon, BarChart2Icon, MessageSquareIcon, FileTextIcon, ThumbsUpIcon, CheckIcon, XIcon, ArrowRightIcon, DownloadIcon, RefreshCwIcon, MoreVerticalIcon, ExternalLinkIcon, ChevronRightIcon, ChevronDownIcon, BarChartIcon, PieChartIcon, LineChartIcon, UserIcon, BuildingIcon, FileIcon, BookOpenIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { useAuth } from '../../contexts/AuthContext';
// Mock data for Planner dashboard
const plannerMockData = {
  kpis: {
    trainingsToday: 12,
    trackOccupancy: 76,
    availableInstructors: {
      available: 8,
      total: 10
    }
  },
  upcomingTrainings: [{
    id: 1,
    date: new Date(new Date().setHours(10, 0, 0, 0)),
    type: 'Sliptraining Basis',
    location: 'Rotterdam',
    color: 'blue',
    instructor: 'Erik de Vries',
    participants: 8
  }, {
    id: 2,
    date: new Date(new Date().setHours(13, 30, 0, 0)),
    type: 'Defensief Rijden',
    location: 'Utrecht',
    color: 'green',
    instructor: 'Lisa Bakker',
    participants: 6
  }, {
    id: 3,
    date: new Date(new Date().setDate(new Date().getDate() + 1)).setHours(9, 0, 0, 0),
    type: 'Sliptraining Gevorderd',
    location: 'Rotterdam',
    color: 'purple',
    instructor: 'Peter Jansen',
    participants: 7
  }, {
    id: 4,
    date: new Date(new Date().setDate(new Date().getDate() + 2)).setHours(11, 0, 0, 0),
    type: 'Defensief Rijden',
    location: 'Amsterdam',
    color: 'green',
    instructor: 'Maria Visser',
    participants: 5
  }, {
    id: 5,
    date: new Date(new Date().setDate(new Date().getDate() + 3)).setHours(14, 0, 0, 0),
    type: 'Sliptraining Basis',
    location: 'Rotterdam',
    color: 'blue',
    instructor: 'Erik de Vries',
    participants: 8
  }],
  recentActivities: [{
    id: 1,
    type: 'update',
    description: "Training 'Sliptraining Basis' gewijzigd",
    timestamp: new Date(new Date().setMinutes(new Date().getMinutes() - 15)),
    icon: EditIcon
  }, {
    id: 2,
    type: 'alert',
    description: 'Instructeur Jan Smit ziek gemeld',
    timestamp: new Date(new Date().setHours(new Date().getHours() - 2)),
    icon: AlertTriangleIcon
  }, {
    id: 3,
    type: 'new',
    description: "Nieuwe klant 'Gemeente Rotterdam' toegevoegd",
    timestamp: new Date(new Date().setHours(new Date().getHours() - 4)),
    icon: UserPlusIcon
  }, {
    id: 4,
    type: 'complete',
    description: "Training 'Defensief Rijden' voltooid",
    timestamp: new Date(new Date().setHours(new Date().getHours() - 6)),
    icon: CheckCircleIcon
  }, {
    id: 5,
    type: 'update',
    description: 'Locatie voor training #4582 gewijzigd',
    timestamp: new Date(new Date().setDate(new Date().getDate() - 1)),
    icon: EditIcon
  }],
  tasksToDo: [{
    id: 1,
    title: 'Instructeur toewijzen aan training #4587',
    priority: 'high',
    dueDate: new Date(new Date().setDate(new Date().getDate() + 1))
  }, {
    id: 2,
    title: 'Klantgegevens bijwerken voor Gemeente Amsterdam',
    priority: 'medium',
    dueDate: new Date(new Date().setDate(new Date().getDate() + 2))
  }, {
    id: 3,
    title: 'Trainingsmateriaal controleren voor Code 95 training',
    priority: 'low',
    dueDate: new Date(new Date().setDate(new Date().getDate() + 3))
  }],
  resourceUtilization: [{
    name: 'Rotterdam',
    value: 92
  }, {
    name: 'Utrecht',
    value: 78
  }, {
    name: 'Amsterdam',
    value: 65
  }, {
    name: 'Eindhoven',
    value: 45
  }]
};
// Mock data for Manager dashboard
const managerMockData = {
  kpis: {
    avgTrainingOccupancy: 82,
    customerSatisfaction: 8.7,
    illnessReports: 3,
    monthlyRevenue: 124500
  },
  busiestLocations: [{
    id: 1,
    name: 'Rotterdam',
    occupancyRate: 92,
    trend: 'up'
  }, {
    id: 2,
    name: 'Utrecht',
    occupancyRate: 87,
    trend: 'up'
  }, {
    id: 3,
    name: 'Amsterdam',
    occupancyRate: 74,
    trend: 'down'
  }],
  topInstructors: [{
    id: 1,
    name: 'Erik de Vries',
    rating: 9.4,
    trainingsCount: 24,
    avatar: null
  }, {
    id: 2,
    name: 'Lisa Bakker',
    rating: 9.2,
    trainingsCount: 18,
    avatar: null
  }, {
    id: 3,
    name: 'Peter Jansen',
    rating: 8.9,
    trainingsCount: 22,
    avatar: null
  }],
  planningWarnings: [{
    id: 1,
    description: 'Tekort aan instructeurs op 12 juni',
    severity: 'high'
  }, {
    id: 2,
    description: 'Slipbaan Rotterdam onderhoud op 15 juni',
    severity: 'medium'
  }, {
    id: 3,
    description: 'Dubbele boeking voor training #4872',
    severity: 'high'
  }],
  recentFeedback: [{
    id: 1,
    trainingType: 'Sliptraining Basis',
    instructor: 'Erik de Vries',
    rating: 9,
    comment: 'Zeer leerzaam en praktijkgericht. Goede begeleiding.',
    date: new Date(new Date().setDate(new Date().getDate() - 1)),
    client: 'Gemeente Rotterdam'
  }, {
    id: 2,
    trainingType: 'Defensief Rijden',
    instructor: 'Lisa Bakker',
    rating: 8,
    comment: 'Duidelijke uitleg, maar iets te weinig praktijktijd.',
    date: new Date(new Date().setDate(new Date().getDate() - 2)),
    client: 'Politie Nederland'
  }, {
    id: 3,
    trainingType: 'Code 95 Training',
    instructor: 'Peter Jansen',
    rating: 10,
    comment: 'Uitstekende training, zeer interactief en informatief.',
    date: new Date(new Date().setDate(new Date().getDate() - 3)),
    client: 'DHL Logistics'
  }],
  revenueByMonth: [{
    month: 'Jan',
    value: 98500
  }, {
    month: 'Feb',
    value: 105000
  }, {
    month: 'Mar',
    value: 110200
  }, {
    month: 'Apr',
    value: 118700
  }, {
    month: 'May',
    value: 124500
  }, {
    month: 'Jun',
    value: 130000
  }],
  trainingsByType: [{
    type: 'Sliptraining',
    count: 45
  }, {
    type: 'Defensief Rijden',
    count: 32
  }, {
    type: 'Code 95',
    count: 28
  }, {
    type: 'Calamiteiten',
    count: 15
  }, {
    type: 'Overig',
    count: 10
  }]
};
// Mock data for Instructor dashboard
const instructorMockData = {
  todaySchedule: [{
    id: 1,
    time: '09:00 - 12:00',
    type: 'Sliptraining Basis',
    location: 'Rotterdam',
    participants: 8,
    color: 'blue',
    client: 'Gemeente Rotterdam',
    notes: 'Speciale aandacht voor parkeermanoeuvres'
  }, {
    id: 2,
    time: '13:30 - 16:30',
    type: 'Defensief Rijden',
    location: 'Utrecht',
    participants: 6,
    color: 'green',
    client: 'ProRail',
    notes: ''
  }],
  upcomingSchedule: [{
    id: 3,
    date: new Date(new Date().setDate(new Date().getDate() + 1)),
    time: '09:00 - 12:30',
    type: 'Code 95 Training',
    location: 'Amsterdam',
    participants: 12,
    color: 'yellow',
    client: 'DHL Logistics'
  }, {
    id: 4,
    date: new Date(new Date().setDate(new Date().getDate() + 2)),
    time: '13:00 - 16:00',
    type: 'Sliptraining Gevorderd',
    location: 'Rotterdam',
    participants: 6,
    color: 'purple',
    client: 'Politie Nederland'
  }],
  recentFeedback: [{
    id: 1,
    trainingType: 'Sliptraining Basis',
    date: new Date(new Date().setDate(new Date().getDate() - 1)),
    rating: 9.2,
    strengths: ['Duidelijke uitleg', 'Goede praktijkoefeningen'],
    improvements: ['Iets meer tijd voor vragen'],
    client: 'Gemeente Rotterdam'
  }, {
    id: 2,
    trainingType: 'Defensief Rijden',
    date: new Date(new Date().setDate(new Date().getDate() - 3)),
    rating: 8.7,
    strengths: ['Interactieve sessie', "Relevante scenario's"],
    improvements: ['Meer visueel materiaal'],
    client: 'ProRail'
  }],
  alerts: [{
    id: 1,
    type: 'schedule_change',
    description: 'Training op 12 juni verplaatst naar Rotterdam',
    timestamp: new Date(new Date().setHours(new Date().getHours() - 2)),
    read: false
  }, {
    id: 2,
    type: 'note',
    description: 'Checklist voor Code 95 training bijgewerkt',
    timestamp: new Date(new Date().setHours(new Date().getHours() - 8)),
    read: true
  }, {
    id: 3,
    type: 'message',
    description: "Bericht van planner: 'Graag materialen controleren voor morgen'",
    timestamp: new Date(new Date().setDate(new Date().getDate() - 1)),
    read: false
  }],
  monthlyTrainings: [{
    month: 'Jan',
    count: 12
  }, {
    month: 'Feb',
    count: 14
  }, {
    month: 'Mar',
    count: 10
  }, {
    month: 'Apr',
    count: 16
  }, {
    month: 'May',
    count: 18
  }, {
    month: 'Jun',
    count: 15
  }],
  trainingsByType: [{
    type: 'Sliptraining',
    count: 22
  }, {
    type: 'Defensief Rijden',
    count: 18
  }, {
    type: 'Code 95',
    count: 12
  }, {
    type: 'Calamiteiten',
    count: 8
  }],
  availability: [{
    day: 'Ma',
    available: true
  }, {
    day: 'Di',
    available: true
  }, {
    day: 'Wo',
    available: false
  }, {
    day: 'Do',
    available: true
  }, {
    day: 'Vr',
    available: true
  }]
};
// Helper function to format time
const formatTime = date => {
  return date.toLocaleTimeString('nl-NL', {
    hour: '2-digit',
    minute: '2-digit'
  });
};
// Helper function to format date
const formatDate = date => {
  return date.toLocaleDateString('nl-NL', {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  });
};
// Helper function to get relative time
const getRelativeTime = date => {
  const now = new Date();
  const diffInMinutes = Math.floor((now - date) / (1000 * 60));
  if (diffInMinutes < 1) return 'Zojuist';
  if (diffInMinutes < 60) return `${diffInMinutes} min. geleden`;
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours} uur geleden`;
  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays} dag${diffInDays > 1 ? 'en' : ''} geleden`;
};
// Color mapping for training types
const getTrainingTypeColor = color => {
  const colorMap = {
    blue: 'bg-blue-100 text-blue-800 border-blue-200',
    green: 'bg-green-100 text-green-800 border-green-200',
    purple: 'bg-purple-100 text-purple-800 border-purple-200',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    red: 'bg-red-100 text-red-800 border-red-200'
  };
  return colorMap[color] || 'bg-gray-100 text-gray-800 border-gray-200';
};
// Activity type to badge variant mapping
const getActivityBadgeVariant = type => {
  const variantMap = {
    update: 'info',
    alert: 'warning',
    new: 'success',
    complete: 'success'
  };
  return variantMap[type] || 'default';
};
// Severity to badge variant mapping
const getSeverityBadgeVariant = severity => {
  const variantMap = {
    high: 'danger',
    medium: 'warning',
    low: 'info'
  };
  return variantMap[severity] || 'default';
};
// Alert type to icon mapping
const getAlertTypeIcon = type => {
  const iconMap = {
    schedule_change: CalendarIcon,
    note: FileTextIcon,
    message: MessageSquareIcon
  };
  return iconMap[type] || BellIcon;
};
// Priority to color mapping
const getPriorityColor = priority => {
  const colorMap = {
    high: 'text-red-600',
    medium: 'text-yellow-600',
    low: 'text-blue-600'
  };
  return colorMap[priority] || 'text-gray-600';
};
export function Dashboard() {
  const {
    role
  } = useAuth();
  // Render dashboard based on user role
  if (role === 'planner') {
    return <PlannerDashboard data-id="element-494" />;
  } else if (role === 'manager') {
    return <ManagerDashboard data-id="element-495" />;
  } else if (role === 'instructor') {
    return <InstructorDashboard data-id="element-496" />;
  }
  // Fallback to planner dashboard
  return <PlannerDashboard data-id="element-497" />;
}
function PlannerDashboard() {
  const [expandedTraining, setExpandedTraining] = useState(null);
  const [showAllActivities, setShowAllActivities] = useState(false);
  // Animation for KPI cards
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // Trigger animations after component mounts
    setIsLoaded(true);
  }, []);
  return <div className="space-y-6" data-id="element-498">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2" data-id="element-499">
        <div data-id="element-500">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-501">
            Planner Dashboard
          </h1>
          <p className="text-gray-500 text-sm mt-1" data-id="element-502">
            Overzicht van trainingen, bezetting en activiteiten
          </p>
        </div>
        <div className="flex gap-2" data-id="element-503">
          <Button variant="outline" size="sm" icon={<RefreshCwIcon size={16} data-id="element-505" />} data-id="element-504">
            Vernieuwen
          </Button>
          <Button variant="primary" size="sm" icon={<PlusIcon size={16} data-id="element-507" />} data-id="element-506">
            Nieuwe Training
          </Button>
        </div>
      </div>
      {/* KPI Widgets */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-508">
        <Card className={`col-span-1 transform transition-all duration-500 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} data-id="element-509">
          <div className="flex items-center p-1" data-id="element-510">
            <div className="p-3 rounded-full bg-blue-100 shadow-sm" data-id="element-511">
              <CalendarIcon className="h-6 w-6 text-blue-600" data-id="element-512" />
            </div>
            <div className="ml-4" data-id="element-513">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-514">
                Trainingen Vandaag
              </h3>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-515">
                {plannerMockData.kpis.trainingsToday}
              </p>
              <p className="text-xs text-gray-500" data-id="element-516">Ingepland voor vandaag</p>
            </div>
          </div>
        </Card>
        <Card className={`col-span-1 transform transition-all duration-500 delay-100 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} data-id="element-517">
          <div className="flex items-center p-1" data-id="element-518">
            <div className="p-3 rounded-full bg-green-100 shadow-sm" data-id="element-519">
              <PercentIcon className="h-6 w-6 text-green-600" data-id="element-520" />
            </div>
            <div className="ml-4 flex-1" data-id="element-521">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-522">
                Slipbaan Bezetting
              </h3>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-523">
                {plannerMockData.kpis.trackOccupancy}%
              </p>
              <div className="w-full h-2 bg-gray-200 rounded-full mt-1" data-id="element-524">
                <div className="h-2 bg-[#B61C1C] rounded-full transition-all duration-1000 ease-out" style={{
                width: isLoaded ? `${plannerMockData.kpis.trackOccupancy}%` : '0%'
              }} data-id="element-525"></div>
              </div>
            </div>
          </div>
        </Card>
        <Card className={`col-span-1 transform transition-all duration-500 delay-200 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} data-id="element-526">
          <div className="flex items-center p-1" data-id="element-527">
            <div className="p-3 rounded-full bg-purple-100 shadow-sm" data-id="element-528">
              <UsersIcon className="h-6 w-6 text-purple-600" data-id="element-529" />
            </div>
            <div className="ml-4" data-id="element-530">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-531">
                Instructeurs Beschikbaar
              </h3>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-532">
                {plannerMockData.kpis.availableInstructors.available}/
                {plannerMockData.kpis.availableInstructors.total}
              </p>
              <div className="flex space-x-1 mt-1" data-id="element-533">
                {[...Array(plannerMockData.kpis.availableInstructors.total)].map((_, i) => <div key={i} className={`h-2 w-2 rounded-full transition-all duration-700 ${isLoaded && i < plannerMockData.kpis.availableInstructors.available ? 'bg-[#B61C1C]' : 'bg-gray-200'}`} style={{
                transitionDelay: `${i * 100}ms`
              }} data-id="element-534"></div>)}
              </div>
            </div>
          </div>
        </Card>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-535">
        {/* Calendar Preview Widget */}
        <Card title="Trainingen Vandaag & Morgen" className="col-span-1 lg:col-span-2" actions={<Button variant="ghost" size="sm" icon={<CalendarIcon size={16} data-id="element-538" />} data-id="element-537">
              Bekijk Week
            </Button>} data-id="element-536">
          <div className="space-y-1" data-id="element-539">
            {plannerMockData.upcomingTrainings.length > 0 ? <div data-id="element-540">
                <div className="space-y-2" data-id="element-541">
                  {plannerMockData.upcomingTrainings.map(training => <div key={training.id} className={`border rounded-lg transition-all duration-200 ${expandedTraining === training.id ? 'bg-gray-50 shadow-sm' : 'hover:bg-gray-50'}`} data-id="element-542">
                      <div className="flex items-start p-3 cursor-pointer" onClick={() => setExpandedTraining(expandedTraining === training.id ? null : training.id)} data-id="element-543">
                        <div className="flex flex-col items-center mr-4 w-16" data-id="element-544">
                          <span className="text-xs font-medium text-gray-500" data-id="element-545">
                            {formatDate(new Date(training.date))}
                          </span>
                          <span className="text-sm font-bold text-gray-900" data-id="element-546">
                            {formatTime(new Date(training.date))}
                          </span>
                        </div>
                        <div className="flex-1" data-id="element-547">
                          <span className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${getTrainingTypeColor(training.color)} mb-1`} data-id="element-548">
                            {training.type}
                          </span>
                          <div className="flex items-center text-sm text-gray-600" data-id="element-549">
                            <MapPinIcon className="h-3 w-3 mr-1" data-id="element-550" />
                            <span data-id="element-551">{training.location}</span>
                          </div>
                        </div>
                        <div className="flex items-center" data-id="element-552">
                          <ChevronDownIcon className={`h-5 w-5 text-gray-400 transform transition-transform ${expandedTraining === training.id ? 'rotate-180' : ''}`} data-id="element-553" />
                        </div>
                      </div>
                      {expandedTraining === training.id && <div className="px-3 pb-3 pt-1 border-t border-gray-100 animate-fadeIn" data-id="element-554">
                          <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-555">
                            <div className="flex items-center" data-id="element-556">
                              <UserIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-557" />
                              <div data-id="element-558">
                                <p className="text-xs text-gray-500" data-id="element-559">
                                  Instructeur
                                </p>
                                <p className="font-medium text-gray-900" data-id="element-560">
                                  {training.instructor}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center" data-id="element-561">
                              <UsersIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-562" />
                              <div data-id="element-563">
                                <p className="text-xs text-gray-500" data-id="element-564">
                                  Deelnemers
                                </p>
                                <p className="font-medium text-gray-900" data-id="element-565">
                                  {training.participants}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-end mt-3 space-x-2" data-id="element-566">
                            <Button variant="outline" size="sm" icon={<EditIcon size={14} data-id="element-568" />} data-id="element-567">
                              Bewerken
                            </Button>
                            <Button variant="primary" size="sm" icon={<ExternalLinkIcon size={14} data-id="element-570" />} data-id="element-569">
                              Details
                            </Button>
                          </div>
                        </div>}
                    </div>)}
                </div>
                <div className="mt-4 text-center" data-id="element-571">
                  <a href="/planner" className="inline-flex items-center text-sm font-medium text-[#B61C1C] hover:text-[#961818] transition-colors" data-id="element-572">
                    Bekijk volledige planner
                    <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-573" />
                  </a>
                </div>
              </div> : <div className="flex items-center justify-center h-48 border border-dashed border-gray-300 rounded-md" data-id="element-574">
                <div className="text-center" data-id="element-575">
                  <CalendarIcon className="h-8 w-8 text-gray-400 mx-auto" data-id="element-576" />
                  <p className="mt-1 text-gray-500 text-sm" data-id="element-577">
                    Geen geplande trainingen
                  </p>
                </div>
              </div>}
          </div>
        </Card>
        {/* Recent Activities Widget */}
        <div className="col-span-1 space-y-6" data-id="element-578">
          <Card title="Recente Activiteiten" className="col-span-1" actions={<Button variant="ghost" size="sm" onClick={() => setShowAllActivities(!showAllActivities)} data-id="element-580">
                {showAllActivities ? 'Minder' : 'Meer'}
              </Button>} data-id="element-579">
            {plannerMockData.recentActivities.length > 0 ? <div className="space-y-3" data-id="element-581">
                {plannerMockData.recentActivities.slice(0, showAllActivities ? plannerMockData.recentActivities.length : 3).map((activity, index) => <div key={activity.id} className={`flex items-start space-x-3 p-2 rounded-md transition-all duration-300 hover:bg-gray-50 ${index === 0 ? 'animate-fadeIn' : ''}`} data-id="element-582">
                      <div className={`p-2 rounded-full ${activity.type === 'alert' ? 'bg-yellow-100' : activity.type === 'new' ? 'bg-green-100' : activity.type === 'complete' ? 'bg-blue-100' : 'bg-gray-100'}`} data-id="element-583">
                        <activity.icon className={`h-4 w-4 ${activity.type === 'alert' ? 'text-yellow-600' : activity.type === 'new' ? 'text-green-600' : activity.type === 'complete' ? 'text-blue-600' : 'text-gray-600'}`} data-id="element-584" />
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-585">
                        <p className="text-sm font-medium text-gray-900 truncate" data-id="element-586">
                          {activity.description}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-587">
                          {getRelativeTime(activity.timestamp)}
                        </p>
                      </div>
                      <Badge variant={getActivityBadgeVariant(activity.type)} data-id="element-588">
                        {activity.type === 'update' ? 'Update' : activity.type === 'alert' ? 'Alert' : activity.type === 'new' ? 'Nieuw' : activity.type === 'complete' ? 'Voltooid' : 'Info'}
                      </Badge>
                    </div>)}
              </div> : <div className="flex items-center justify-center h-48 border border-dashed border-gray-300 rounded-md" data-id="element-589">
                <div className="text-center" data-id="element-590">
                  <BellIcon className="h-8 w-8 text-gray-400 mx-auto" data-id="element-591" />
                  <p className="mt-1 text-gray-500 text-sm" data-id="element-592">
                    Geen recente activiteiten
                  </p>
                </div>
              </div>}
          </Card>
          {/* Tasks Widget */}
          <Card title="Taken" className="col-span-1" actions={<Button variant="ghost" size="sm" icon={<PlusIcon size={16} data-id="element-595" />} data-id="element-594">
                Nieuwe Taak
              </Button>} data-id="element-593">
            {plannerMockData.tasksToDo.length > 0 ? <div className="space-y-2" data-id="element-596">
                {plannerMockData.tasksToDo.map(task => <div key={task.id} className="flex items-center justify-between p-3 border border-gray-200 rounded-md hover:bg-gray-50 transition-colors" data-id="element-597">
                    <div className="flex items-start space-x-3" data-id="element-598">
                      <div className="h-5 w-5 rounded-full border-2 border-gray-300 flex-shrink-0 cursor-pointer hover:border-[#B61C1C] transition-colors" data-id="element-599"></div>
                      <div data-id="element-600">
                        <p className="text-sm font-medium text-gray-900" data-id="element-601">
                          {task.title}
                        </p>
                        <div className="flex items-center mt-1" data-id="element-602">
                          <span className={`text-xs ${getPriorityColor(task.priority)} font-medium`} data-id="element-603">
                            {task.priority === 'high' ? 'Hoge prioriteit' : task.priority === 'medium' ? 'Medium prioriteit' : 'Lage prioriteit'}
                          </span>
                          <span className="mx-1 text-gray-300" data-id="element-604">•</span>
                          <span className="text-xs text-gray-500" data-id="element-605">
                            {formatDate(task.dueDate)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Button variant="ghost" size="sm" className="text-gray-500 hover:text-gray-700" data-id="element-606">
                      <MoreVerticalIcon size={16} data-id="element-607" />
                    </Button>
                  </div>)}
              </div> : <div className="flex items-center justify-center h-32 border border-dashed border-gray-300 rounded-md" data-id="element-608">
                <div className="text-center" data-id="element-609">
                  <CheckIcon className="h-8 w-8 text-gray-400 mx-auto" data-id="element-610" />
                  <p className="mt-1 text-gray-500 text-sm" data-id="element-611">
                    Geen openstaande taken
                  </p>
                </div>
              </div>}
          </Card>
        </div>
      </div>
      {/* Resource Utilization */}
      <Card title="Bezetting per Locatie" className="col-span-1" actions={<Button variant="ghost" size="sm" icon={<DownloadIcon size={16} data-id="element-614" />} data-id="element-613">
            Exporteren
          </Button>} data-id="element-612">
        <div className="p-2" data-id="element-615">
          <div className="space-y-4" data-id="element-616">
            {plannerMockData.resourceUtilization.map(location => <div key={location.name} className="space-y-1" data-id="element-617">
                <div className="flex justify-between items-center" data-id="element-618">
                  <span className="text-sm font-medium text-gray-700" data-id="element-619">
                    {location.name}
                  </span>
                  <span className="text-sm font-bold text-gray-900" data-id="element-620">
                    {location.value}%
                  </span>
                </div>
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-621">
                  <div className={`h-2 rounded-full transition-all duration-1000 ease-out ${location.value > 90 ? 'bg-red-500' : location.value > 70 ? 'bg-[#B61C1C]' : location.value > 50 ? 'bg-yellow-500' : 'bg-green-500'}`} style={{
                width: `${location.value}%`
              }} data-id="element-622"></div>
                </div>
              </div>)}
          </div>
        </div>
      </Card>
    </div>;
}
function ManagerDashboard() {
  const [activeTab, setActiveTab] = useState('overview');
  const [expandedWarning, setExpandedWarning] = useState(null);
  // Animation for KPI cards
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // Trigger animations after component mounts
    setIsLoaded(true);
  }, []);
  return <div className="space-y-6" data-id="element-623">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2" data-id="element-624">
        <div data-id="element-625">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-626">
            Management Dashboard
          </h1>
          <p className="text-gray-500 text-sm mt-1" data-id="element-627">
            Prestaties, feedback en planning inzichten
          </p>
        </div>
        <div className="flex gap-2" data-id="element-628">
          <Button variant="outline" size="sm" icon={<DownloadIcon size={16} data-id="element-630" />} data-id="element-629">
            Exporteren
          </Button>
          <Button variant="primary" size="sm" icon={<BarChartIcon size={16} data-id="element-632" />} data-id="element-631">
            Rapportages
          </Button>
        </div>
      </div>
      {/* Dashboard Tabs */}
      <div className="border-b border-gray-200" data-id="element-633">
        <div className="flex space-x-4" data-id="element-634">
          <button className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${activeTab === 'overview' ? 'border-[#B61C1C] text-[#B61C1C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('overview')} data-id="element-635">
            Overzicht
          </button>
          <button className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${activeTab === 'revenue' ? 'border-[#B61C1C] text-[#B61C1C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('revenue')} data-id="element-636">
            Omzet
          </button>
          <button className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${activeTab === 'performance' ? 'border-[#B61C1C] text-[#B61C1C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('performance')} data-id="element-637">
            Prestaties
          </button>
        </div>
      </div>
      {activeTab === 'overview' && <>
          {/* KPI Widgets */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-638">
            <Card className={`col-span-1 transform transition-all duration-500 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} data-id="element-639">
              <div className="flex items-center p-1" data-id="element-640">
                <div className="p-3 rounded-full bg-blue-100 shadow-sm" data-id="element-641">
                  <PercentIcon className="h-6 w-6 text-blue-600" data-id="element-642" />
                </div>
                <div className="ml-4" data-id="element-643">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-644">
                    Gemiddelde Bezetting
                  </h3>
                  <p className="text-2xl font-semibold text-gray-900" data-id="element-645">
                    {managerMockData.kpis.avgTrainingOccupancy}%
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-646">Deze maand</p>
                </div>
              </div>
            </Card>
            <Card className={`col-span-1 transform transition-all duration-500 delay-100 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} data-id="element-647">
              <div className="flex items-center p-1" data-id="element-648">
                <div className="p-3 rounded-full bg-green-100 shadow-sm" data-id="element-649">
                  <StarIcon className="h-6 w-6 text-green-600" data-id="element-650" />
                </div>
                <div className="ml-4" data-id="element-651">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-652">
                    Klanttevredenheid
                  </h3>
                  <p className="text-2xl font-semibold text-gray-900" data-id="element-653">
                    {managerMockData.kpis.customerSatisfaction}
                  </p>
                  <div className="flex items-center mt-1" data-id="element-654">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-3 w-3 ${i < Math.floor(managerMockData.kpis.customerSatisfaction / 2) ? 'text-yellow-400' : 'text-gray-300'}`} data-id="element-655" />)}
                    <span className="text-xs text-gray-500 ml-1" data-id="element-656">
                      Gemiddeld
                    </span>
                  </div>
                </div>
              </div>
            </Card>
            <Card className={`col-span-1 transform transition-all duration-500 delay-200 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} data-id="element-657">
              <div className="flex items-center p-1" data-id="element-658">
                <div className="p-3 rounded-full bg-red-100 shadow-sm" data-id="element-659">
                  <AlertTriangleIcon className="h-6 w-6 text-red-600" data-id="element-660" />
                </div>
                <div className="ml-4" data-id="element-661">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-662">
                    Ziekmeldingen
                  </h3>
                  <p className="text-2xl font-semibold text-gray-900" data-id="element-663">
                    {managerMockData.kpis.illnessReports}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-664">Afgelopen 7 dagen</p>
                </div>
              </div>
            </Card>
            <Card className={`col-span-1 transform transition-all duration-500 delay-300 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} data-id="element-665">
              <div className="flex items-center p-1" data-id="element-666">
                <div className="p-3 rounded-full bg-purple-100 shadow-sm" data-id="element-667">
                  <TrendingUpIcon className="h-6 w-6 text-purple-600" data-id="element-668" />
                </div>
                <div className="ml-4" data-id="element-669">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-670">
                    Omzet Deze Maand
                  </h3>
                  <p className="text-2xl font-semibold text-gray-900" data-id="element-671">
                    €
                    {managerMockData.kpis.monthlyRevenue.toLocaleString('nl-NL')}
                  </p>
                  <div className="flex items-center text-xs text-green-600" data-id="element-672">
                    <TrendingUpIcon className="h-3 w-3 mr-1" data-id="element-673" />
                    <span data-id="element-674">+4.6% t.o.v. vorige maand</span>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-675">
            {/* Busiest Locations & Top Instructors */}
            <div className="col-span-1 space-y-6" data-id="element-676">
              <Card title="Drukste Locaties" className="col-span-1" data-id="element-677">
                <div className="space-y-4 p-2" data-id="element-678">
                  {managerMockData.busiestLocations.map(location => <div key={location.id} className="flex items-center justify-between p-2 rounded-md hover:bg-gray-50 transition-colors" data-id="element-679">
                      <div className="flex items-center" data-id="element-680">
                        <MapPinIcon className="h-4 w-4 text-gray-500 mr-2" data-id="element-681" />
                        <span className="text-sm font-medium text-gray-900" data-id="element-682">
                          {location.name}
                        </span>
                      </div>
                      <div className="flex items-center" data-id="element-683">
                        <span className="text-sm font-bold text-gray-900 mr-2" data-id="element-684">
                          {location.occupancyRate}%
                        </span>
                        {location.trend === 'up' ? <TrendingUpIcon className="h-4 w-4 text-green-500" data-id="element-685" /> : <TrendingDownIcon className="h-4 w-4 text-red-500" data-id="element-686" />}
                      </div>
                    </div>)}
                </div>
              </Card>
              <Card title="Top Instructeurs" className="col-span-1" data-id="element-687">
                <div className="space-y-4 p-2" data-id="element-688">
                  {managerMockData.topInstructors.map(instructor => <div key={instructor.id} className="flex items-center justify-between p-2 rounded-md hover:bg-gray-50 transition-colors" data-id="element-689">
                      <div className="flex items-center" data-id="element-690">
                        <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 mr-2" data-id="element-691">
                          {instructor.avatar ? <img src={instructor.avatar} alt={instructor.name} className="w-8 h-8 rounded-full object-cover" data-id="element-692" /> : instructor.name.charAt(0)}
                        </div>
                        <div className="flex-1" data-id="element-693">
                          <p className="text-sm font-medium text-gray-900" data-id="element-694">
                            {instructor.name}
                          </p>
                          <div className="flex items-center" data-id="element-695">
                            <StarIcon className="h-3 w-3 text-yellow-400 mr-1" data-id="element-696" />
                            <span className="text-xs text-gray-500" data-id="element-697">
                              {instructor.rating}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-698">
                        <span className="text-xs text-gray-500 mr-2" data-id="element-699">
                          {instructor.trainingsCount} trainingen
                        </span>
                        <Badge variant="success" data-id="element-700">Top</Badge>
                      </div>
                    </div>)}
                </div>
              </Card>
            </div>
            {/* Training Distribution */}
            <Card title="Trainingen per Type" className="col-span-1" actions={<Button variant="ghost" size="sm" icon={<DownloadIcon size={16} data-id="element-703" />} data-id="element-702">
                  Export
                </Button>} data-id="element-701">
              <div className="p-4 space-y-4" data-id="element-704">
                {managerMockData.trainingsByType.map(item => <div key={item.type} className="space-y-1" data-id="element-705">
                    <div className="flex justify-between items-center" data-id="element-706">
                      <span className="text-sm font-medium text-gray-700" data-id="element-707">
                        {item.type}
                      </span>
                      <span className="text-sm font-bold text-gray-900" data-id="element-708">
                        {item.count}
                      </span>
                    </div>
                    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-709">
                      <div className="h-2 bg-[#B61C1C] rounded-full transition-all duration-1000 ease-out" style={{
                  width: `${item.count / Math.max(...managerMockData.trainingsByType.map(t => t.count)) * 100}%`
                }} data-id="element-710"></div>
                    </div>
                  </div>)}
              </div>
            </Card>
            {/* Planning Warnings */}
            <Card title="Planning Waarschuwingen" className="col-span-1" actions={<Button variant="ghost" size="sm" data-id="element-712">
                  Alle Bekijken
                </Button>} data-id="element-711">
              <div className="space-y-3 p-2" data-id="element-713">
                {managerMockData.planningWarnings.map(warning => <div key={warning.id} className={`rounded-md border transition-all duration-200 ${expandedWarning === warning.id ? 'bg-gray-50 shadow-sm' : 'hover:bg-gray-50'} ${warning.severity === 'high' ? 'border-red-200' : warning.severity === 'medium' ? 'border-yellow-200' : 'border-blue-200'}`} data-id="element-714">
                    <div className="flex items-start p-3 cursor-pointer" onClick={() => setExpandedWarning(expandedWarning === warning.id ? null : warning.id)} data-id="element-715">
                      <AlertTriangleIcon className={`h-5 w-5 flex-shrink-0 mr-3 ${warning.severity === 'high' ? 'text-red-500' : warning.severity === 'medium' ? 'text-yellow-500' : 'text-blue-500'}`} data-id="element-716" />
                      <div className="flex-1" data-id="element-717">
                        <p className="text-sm text-gray-900" data-id="element-718">
                          {warning.description}
                        </p>
                      </div>
                      <Badge variant={getSeverityBadgeVariant(warning.severity)} data-id="element-719">
                        {warning.severity === 'high' ? 'Hoog' : warning.severity === 'medium' ? 'Middel' : 'Laag'}
                      </Badge>
                    </div>
                    {expandedWarning === warning.id && <div className="px-3 pb-3 border-t border-gray-200 mt-1 ml-11 animate-fadeIn" data-id="element-720">
                        <div className="pt-2 text-sm text-gray-600" data-id="element-721">
                          <p data-id="element-722">Aanbevolen actie:</p>
                          <p className="mt-1" data-id="element-723">
                            {warning.severity === 'high' ? 'Neem direct actie om dit probleem op te lossen. Contacteer de planner en betrokken instructeurs.' : warning.severity === 'medium' ? 'Houd deze situatie in de gaten en plan preventieve maatregelen.' : 'Bekijk de situatie bij de volgende planningsronde.'}
                          </p>
                        </div>
                        <div className="flex justify-end mt-3 space-x-2" data-id="element-724">
                          <Button variant="outline" size="sm" data-id="element-725">
                            Negeren
                          </Button>
                          <Button variant="primary" size="sm" data-id="element-726">
                            Actie Ondernemen
                          </Button>
                        </div>
                      </div>}
                  </div>)}
              </div>
            </Card>
          </div>
          {/* Recent Feedback */}
          <Card title="Recente Feedback" actions={<Button variant="ghost" size="sm" data-id="element-728">
                Alle Feedback
              </Button>} data-id="element-727">
            <div className="space-y-4 p-2" data-id="element-729">
              {managerMockData.recentFeedback.map(feedback => <div key={feedback.id} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors" data-id="element-730">
                  <div className="flex justify-between mb-2" data-id="element-731">
                    <div data-id="element-732">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-733">
                        {feedback.trainingType}
                      </h4>
                      <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-734">
                        <UserIcon className="h-3 w-3 mr-1" data-id="element-735" />
                        <span data-id="element-736">Instructeur: {feedback.instructor}</span>
                        <span className="mx-1" data-id="element-737">•</span>
                        <BuildingIcon className="h-3 w-3 mr-1" data-id="element-738" />
                        <span data-id="element-739">Klant: {feedback.client}</span>
                      </div>
                    </div>
                    <div className="flex items-center bg-gray-100 px-2 py-1 rounded-full" data-id="element-740">
                      <StarIcon className="h-3 w-3 text-yellow-400 mr-1" data-id="element-741" />
                      <span className="text-xs font-medium" data-id="element-742">
                        {feedback.rating}/10
                      </span>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 italic bg-gray-50 p-2 rounded border-l-2 border-gray-200" data-id="element-743">
                    "{feedback.comment}"
                  </p>
                  <div className="flex justify-between items-center mt-2" data-id="element-744">
                    <p className="text-xs text-gray-500" data-id="element-745">
                      {formatDate(feedback.date)}
                    </p>
                    <Button variant="ghost" size="sm" data-id="element-746">
                      Details
                    </Button>
                  </div>
                </div>)}
            </div>
          </Card>
        </>}
      {activeTab === 'revenue' && <div className="space-y-6" data-id="element-747">
          <Card title="Omzetontwikkeling" data-id="element-748">
            <div className="p-4 h-64 flex items-center justify-center" data-id="element-749">
              <div className="text-center text-gray-500" data-id="element-750">
                <BarChart2Icon className="h-12 w-12 mx-auto text-gray-300" data-id="element-751" />
                <p className="mt-2" data-id="element-752">Omzetgrafiek wordt hier weergegeven</p>
              </div>
            </div>
          </Card>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-753">
            <Card title="Omzet per Klant" data-id="element-754">
              <div className="p-4 h-64 flex items-center justify-center" data-id="element-755">
                <div className="text-center text-gray-500" data-id="element-756">
                  <PieChartIcon className="h-12 w-12 mx-auto text-gray-300" data-id="element-757" />
                  <p className="mt-2" data-id="element-758">
                    Klantenverdeling wordt hier weergegeven
                  </p>
                </div>
              </div>
            </Card>
            <Card title="Omzet per Training" data-id="element-759">
              <div className="p-4 h-64 flex items-center justify-center" data-id="element-760">
                <div className="text-center text-gray-500" data-id="element-761">
                  <BarChartIcon className="h-12 w-12 mx-auto text-gray-300" data-id="element-762" />
                  <p className="mt-2" data-id="element-763">
                    Trainingsverdeling wordt hier weergegeven
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>}
      {activeTab === 'performance' && <div className="space-y-6" data-id="element-764">
          <Card title="Instructeur Prestaties" data-id="element-765">
            <div className="p-4 h-64 flex items-center justify-center" data-id="element-766">
              <div className="text-center text-gray-500" data-id="element-767">
                <LineChartIcon className="h-12 w-12 mx-auto text-gray-300" data-id="element-768" />
                <p className="mt-2" data-id="element-769">Prestatiegrafiek wordt hier weergegeven</p>
              </div>
            </div>
          </Card>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-770">
            <Card title="Trainingseffectiviteit" data-id="element-771">
              <div className="p-4 h-64 flex items-center justify-center" data-id="element-772">
                <div className="text-center text-gray-500" data-id="element-773">
                  <BarChartIcon className="h-12 w-12 mx-auto text-gray-300" data-id="element-774" />
                  <p className="mt-2" data-id="element-775">
                    Effectiviteitsgegevens worden hier weergegeven
                  </p>
                </div>
              </div>
            </Card>
            <Card title="Klanttevredenheid Trend" data-id="element-776">
              <div className="p-4 h-64 flex items-center justify-center" data-id="element-777">
                <div className="text-center text-gray-500" data-id="element-778">
                  <LineChartIcon className="h-12 w-12 mx-auto text-gray-300" data-id="element-779" />
                  <p className="mt-2" data-id="element-780">
                    Tevredenheidstrend wordt hier weergegeven
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>}
    </div>;
}
function InstructorDashboard() {
  const [expandedTraining, setExpandedTraining] = useState(null);
  const [expandedAlert, setExpandedAlert] = useState(null);
  // Animation for schedule cards
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // Trigger animations after component mounts
    setIsLoaded(true);
  }, []);
  return <div className="space-y-6" data-id="element-781">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2" data-id="element-782">
        <div data-id="element-783">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-784">Mijn Dashboard</h1>
          <p className="text-gray-500 text-sm mt-1" data-id="element-785">
            Overzicht van trainingen, feedback en meldingen
          </p>
        </div>
        <div className="flex gap-2" data-id="element-786">
          <Button variant="outline" size="sm" icon={<RefreshCwIcon size={16} data-id="element-788" />} data-id="element-787">
            Vernieuwen
          </Button>
          <Button variant="primary" size="sm" icon={<CalendarIcon size={16} data-id="element-790" />} data-id="element-789">
            Bekijk Agenda
          </Button>
        </div>
      </div>
      {/* Availability status */}
      <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm" data-id="element-791">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3" data-id="element-792">
          <div className="flex items-center" data-id="element-793">
            <div className="w-10 h-10 rounded-full bg-[#B61C1C] flex items-center justify-center text-white mr-3" data-id="element-794">
              <UserIcon size={20} data-id="element-795" />
            </div>
            <div data-id="element-796">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-797">
                Welkom terug!
              </h2>
              <p className="text-sm text-gray-600" data-id="element-798">
                Je hebt vandaag 2 trainingen ingepland
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-2" data-id="element-799">
            <div className="text-sm text-gray-600 hidden md:block" data-id="element-800">
              Beschikbaarheid deze week:
            </div>
            <div className="flex space-x-1" data-id="element-801">
              {instructorMockData.availability.map(day => <div key={day.day} className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium ${day.available ? 'bg-green-100 text-green-800 border border-green-200' : 'bg-gray-100 text-gray-400 border border-gray-200'}`} title={day.available ? 'Beschikbaar' : 'Niet beschikbaar'} data-id="element-802">
                  {day.day}
                </div>)}
            </div>
            <Button variant="outline" size="sm" data-id="element-803">
              Wijzigen
            </Button>
          </div>
        </div>
      </div>
      {/* Today's Schedule */}
      <Card title="Mijn Schema Vandaag" className="col-span-1" actions={<Badge variant="info" data-id="element-805">
            {instructorMockData.todaySchedule.length} Trainingen
          </Badge>} data-id="element-804">
        {instructorMockData.todaySchedule.length > 0 ? <div className="space-y-4 p-2" data-id="element-806">
            {instructorMockData.todaySchedule.map((session, index) => <div key={session.id} className={`border rounded-lg transition-all duration-300 ${expandedTraining === session.id ? 'bg-gray-50 shadow-sm' : 'hover:bg-gray-50'} transform ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-807">
                <div className="flex items-start p-3 cursor-pointer" onClick={() => setExpandedTraining(expandedTraining === session.id ? null : session.id)} data-id="element-808">
                  <div className="flex flex-col items-center mr-4 w-20" data-id="element-809">
                    <span className="text-xs font-medium text-gray-500" data-id="element-810">
                      Vandaag
                    </span>
                    <span className="text-sm font-bold text-gray-900" data-id="element-811">
                      {session.time}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-812">
                    <span className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${getTrainingTypeColor(session.color)} mb-2`} data-id="element-813">
                      {session.type}
                    </span>
                    <div className="flex items-center text-sm text-gray-600 mb-1" data-id="element-814">
                      <MapPinIcon className="h-3 w-3 mr-1" data-id="element-815" />
                      <span data-id="element-816">{session.location}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600" data-id="element-817">
                      <UsersIcon className="h-3 w-3 mr-1" data-id="element-818" />
                      <span data-id="element-819">{session.participants} deelnemers</span>
                    </div>
                  </div>
                  <ChevronDownIcon className={`h-5 w-5 text-gray-400 transform transition-transform ${expandedTraining === session.id ? 'rotate-180' : ''}`} data-id="element-820" />
                </div>
                {expandedTraining === session.id && <div className="px-3 pb-3 pt-1 border-t border-gray-100 ml-24 animate-fadeIn" data-id="element-821">
                    <div className="space-y-3" data-id="element-822">
                      <div className="flex items-start" data-id="element-823">
                        <BuildingIcon className="h-4 w-4 text-gray-400 mr-2 mt-0.5" data-id="element-824" />
                        <div data-id="element-825">
                          <p className="text-xs text-gray-500" data-id="element-826">Klant</p>
                          <p className="font-medium text-gray-900" data-id="element-827">
                            {session.client}
                          </p>
                        </div>
                      </div>
                      {session.notes && <div className="flex items-start" data-id="element-828">
                          <FileTextIcon className="h-4 w-4 text-gray-400 mr-2 mt-0.5" data-id="element-829" />
                          <div data-id="element-830">
                            <p className="text-xs text-gray-500" data-id="element-831">Notities</p>
                            <p className="text-sm text-gray-900" data-id="element-832">
                              {session.notes}
                            </p>
                          </div>
                        </div>}
                    </div>
                    <div className="flex justify-end mt-3 space-x-2" data-id="element-833">
                      <Button variant="outline" size="sm" icon={<FileTextIcon size={14} data-id="element-835" />} data-id="element-834">
                        Materiaal
                      </Button>
                      <Button variant="primary" size="sm" icon={<ExternalLinkIcon size={14} data-id="element-837" />} data-id="element-836">
                        Details
                      </Button>
                    </div>
                  </div>}
              </div>)}
          </div> : <div className="flex items-center justify-center h-32 border border-dashed border-gray-300 rounded-md" data-id="element-838">
            <div className="text-center" data-id="element-839">
              <CalendarIcon className="h-8 w-8 text-gray-400 mx-auto" data-id="element-840" />
              <p className="mt-1 text-gray-500 text-sm" data-id="element-841">
                Geen trainingen vandaag
              </p>
            </div>
          </div>}
      </Card>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-842">
        {/* Upcoming Schedule */}
        <Card title="Aankomende Trainingen" className="col-span-1" actions={<Button variant="ghost" size="sm" icon={<CalendarIcon size={16} data-id="element-845" />} data-id="element-844">
              Alle Bekijken
            </Button>} data-id="element-843">
          {instructorMockData.upcomingSchedule.length > 0 ? <div className="space-y-3 p-2" data-id="element-846">
              {instructorMockData.upcomingSchedule.map(session => <div key={session.id} className="flex items-start p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-847">
                  <div className="flex flex-col items-center mr-4 w-16" data-id="element-848">
                    <span className="text-xs font-medium text-gray-500" data-id="element-849">
                      {formatDate(session.date)}
                    </span>
                    <span className="text-sm font-bold text-gray-900" data-id="element-850">
                      {session.time.split(' - ')[0]}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-851">
                    <span className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${getTrainingTypeColor(session.color)} mb-1`} data-id="element-852">
                      {session.type}
                    </span>
                    <div className="flex items-center text-sm text-gray-600" data-id="element-853">
                      <MapPinIcon className="h-3 w-3 mr-1" data-id="element-854" />
                      <span data-id="element-855">{session.location}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-856">
                      <BuildingIcon className="h-3 w-3 mr-1" data-id="element-857" />
                      <span data-id="element-858">{session.client}</span>
                    </div>
                  </div>
                  <Button variant="ghost" size="sm" data-id="element-859">
                    Details
                  </Button>
                </div>)}
            </div> : <div className="flex items-center justify-center h-32 border border-dashed border-gray-300 rounded-md" data-id="element-860">
              <div className="text-center" data-id="element-861">
                <CalendarIcon className="h-8 w-8 text-gray-400 mx-auto" data-id="element-862" />
                <p className="mt-1 text-gray-500 text-sm" data-id="element-863">
                  Geen aankomende trainingen
                </p>
              </div>
            </div>}
        </Card>
        {/* Alerts and Messages */}
        <Card title="Meldingen" className="col-span-1" actions={<Badge variant="danger" data-id="element-865">
              {instructorMockData.alerts.filter(a => !a.read).length} Nieuw
            </Badge>} data-id="element-864">
          {instructorMockData.alerts.length > 0 ? <div className="space-y-3 p-2" data-id="element-866">
              {instructorMockData.alerts.map(alert => {
            const AlertIcon = getAlertTypeIcon(alert.type);
            return <div key={alert.id} className={`border rounded-lg transition-all duration-200 ${expandedAlert === alert.id ? 'bg-gray-50 shadow-sm' : 'hover:bg-gray-50'} ${!alert.read ? 'border-blue-200 bg-blue-50' : 'border-gray-200'}`} data-id="element-867">
                    <div className="flex items-start p-3 cursor-pointer" onClick={() => setExpandedAlert(expandedAlert === alert.id ? null : alert.id)} data-id="element-868">
                      <div className={`p-2 rounded-full flex-shrink-0 ${alert.type === 'schedule_change' ? 'bg-purple-100' : alert.type === 'note' ? 'bg-yellow-100' : 'bg-green-100'}`} data-id="element-869">
                        <AlertIcon className={`h-4 w-4 ${alert.type === 'schedule_change' ? 'text-purple-600' : alert.type === 'note' ? 'text-yellow-600' : 'text-green-600'}`} data-id="element-870" />
                      </div>
                      <div className="flex-1 mx-3" data-id="element-871">
                        <p className="text-sm font-medium text-gray-900" data-id="element-872">
                          {alert.description}
                        </p>
                        <p className="text-xs text-gray-500 mt-1" data-id="element-873">
                          {getRelativeTime(alert.timestamp)}
                        </p>
                      </div>
                      <div className="flex items-center" data-id="element-874">
                        {!alert.read && <div className="w-2 h-2 rounded-full bg-blue-600 mr-2" data-id="element-875"></div>}
                        <ChevronDownIcon className={`h-5 w-5 text-gray-400 transform transition-transform ${expandedAlert === alert.id ? 'rotate-180' : ''}`} data-id="element-876" />
                      </div>
                    </div>
                    {expandedAlert === alert.id && <div className="px-3 pb-3 border-t border-gray-200 ml-11 animate-fadeIn" data-id="element-877">
                        <div className="pt-2 text-sm text-gray-600" data-id="element-878">
                          <p data-id="element-879">
                            {alert.type === 'schedule_change' ? 'Je rooster is aangepast. Bekijk de details in je agenda.' : alert.type === 'note' ? 'Er is een notitie of document bijgewerkt.' : 'Je hebt een nieuw bericht ontvangen.'}
                          </p>
                        </div>
                        <div className="flex justify-end mt-3 space-x-2" data-id="element-880">
                          <Button variant="outline" size="sm" data-id="element-881">
                            Markeer als gelezen
                          </Button>
                          <Button variant="primary" size="sm" data-id="element-882">
                            Bekijk Details
                          </Button>
                        </div>
                      </div>}
                  </div>;
          })}
            </div> : <div className="flex items-center justify-center h-32 border border-dashed border-gray-300 rounded-md" data-id="element-883">
              <div className="text-center" data-id="element-884">
                <BellIcon className="h-8 w-8 text-gray-400 mx-auto" data-id="element-885" />
                <p className="mt-1 text-gray-500 text-sm" data-id="element-886">Geen meldingen</p>
              </div>
            </div>}
        </Card>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-887">
        {/* Recent Feedback */}
        <Card title="Recente Feedback" className="col-span-1" actions={<Button variant="ghost" size="sm" icon={<ExternalLinkIcon size={16} data-id="element-890" />} data-id="element-889">
              Alle Feedback
            </Button>} data-id="element-888">
          {instructorMockData.recentFeedback.length > 0 ? <div className="space-y-4 p-2" data-id="element-891">
              {instructorMockData.recentFeedback.map(feedback => <div key={feedback.id} className="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 transition-colors" data-id="element-892">
                  <div className="flex justify-between mb-2" data-id="element-893">
                    <div data-id="element-894">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-895">
                        {feedback.trainingType}
                      </h4>
                      <div className="flex items-center text-xs text-gray-500" data-id="element-896">
                        <BuildingIcon className="h-3 w-3 mr-1" data-id="element-897" />
                        <span data-id="element-898">{feedback.client}</span>
                        <span className="mx-1" data-id="element-899">•</span>
                        <span data-id="element-900">{formatDate(feedback.date)}</span>
                      </div>
                    </div>
                    <div className="flex items-center bg-gray-100 px-2 py-1 rounded-full" data-id="element-901">
                      <StarIcon className="h-3 w-3 text-yellow-400 mr-1" data-id="element-902" />
                      <span className="text-xs font-medium" data-id="element-903">
                        {feedback.rating}
                      </span>
                    </div>
                  </div>
                  <div className="mb-2" data-id="element-904">
                    <p className="text-xs font-medium text-gray-500 mb-1" data-id="element-905">
                      Sterke punten:
                    </p>
                    <div className="flex flex-wrap gap-1" data-id="element-906">
                      {feedback.strengths.map((strength, idx) => <span key={idx} className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-100 text-green-800" data-id="element-907">
                          <CheckIcon className="h-3 w-3 mr-1" data-id="element-908" />
                          {strength}
                        </span>)}
                    </div>
                  </div>
                  <div data-id="element-909">
                    <p className="text-xs font-medium text-gray-500 mb-1" data-id="element-910">
                      Verbeterpunten:
                    </p>
                    <div className="flex flex-wrap gap-1" data-id="element-911">
                      {feedback.improvements.map((improvement, idx) => <span key={idx} className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800" data-id="element-912">
                          <XIcon className="h-3 w-3 mr-1" data-id="element-913" />
                          {improvement}
                        </span>)}
                    </div>
                  </div>
                </div>)}
            </div> : <div className="flex items-center justify-center h-32 border border-dashed border-gray-300 rounded-md" data-id="element-914">
              <div className="text-center" data-id="element-915">
                <MessageSquareIcon className="h-8 w-8 text-gray-400 mx-auto" data-id="element-916" />
                <p className="mt-1 text-gray-500 text-sm" data-id="element-917">
                  Geen recente feedback
                </p>
              </div>
            </div>}
        </Card>
        {/* Training Statistics */}
        <Card title="Trainingsstatistieken" className="col-span-1" actions={<Button variant="ghost" size="sm" icon={<DownloadIcon size={16} data-id="element-920" />} data-id="element-919">
              Export
            </Button>} data-id="element-918">
          <div className="p-4 space-y-6" data-id="element-921">
            <div data-id="element-922">
              <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-923">
                Trainingen per Maand
              </h4>
              <div className="h-32 flex items-end space-x-2" data-id="element-924">
                {instructorMockData.monthlyTrainings.map(item => <div key={item.month} className="flex flex-col items-center flex-1" data-id="element-925">
                    <div className="w-full bg-[#B61C1C] rounded-t transition-all duration-1000 ease-out" style={{
                  height: `${item.count / Math.max(...instructorMockData.monthlyTrainings.map(t => t.count)) * 100}%`,
                  opacity: isLoaded ? 1 : 0
                }} data-id="element-926"></div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-927">
                      {item.month}
                    </div>
                  </div>)}
              </div>
            </div>
            <div data-id="element-928">
              <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-929">
                Trainingen per Type
              </h4>
              <div className="space-y-2" data-id="element-930">
                {instructorMockData.trainingsByType.map(item => <div key={item.type} className="space-y-1" data-id="element-931">
                    <div className="flex justify-between items-center" data-id="element-932">
                      <span className="text-sm text-gray-700" data-id="element-933">{item.type}</span>
                      <span className="text-sm font-medium text-gray-900" data-id="element-934">
                        {item.count}
                      </span>
                    </div>
                    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-935">
                      <div className="h-2 bg-[#B61C1C] rounded-full transition-all duration-1000 ease-out" style={{
                    width: `${item.count / Math.max(...instructorMockData.trainingsByType.map(t => t.count)) * 100}%`,
                    opacity: isLoaded ? 1 : 0
                  }} data-id="element-936"></div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </Card>
      </div>
      {/* Quick Actions */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-937">
        <Card className="col-span-1 p-4 hover:shadow-md transition-shadow cursor-pointer" data-id="element-938">
          <div className="flex flex-col items-center text-center" data-id="element-939">
            <div className="p-3 rounded-full bg-blue-100 mb-3" data-id="element-940">
              <CalendarIcon className="h-6 w-6 text-blue-600" data-id="element-941" />
            </div>
            <h3 className="text-sm font-medium text-gray-900" data-id="element-942">
              Bekijk Rooster
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-943">Plan je werkdagen</p>
          </div>
        </Card>
        <Card className="col-span-1 p-4 hover:shadow-md transition-shadow cursor-pointer" data-id="element-944">
          <div className="flex flex-col items-center text-center" data-id="element-945">
            <div className="p-3 rounded-full bg-green-100 mb-3" data-id="element-946">
              <FileTextIcon className="h-6 w-6 text-green-600" data-id="element-947" />
            </div>
            <h3 className="text-sm font-medium text-gray-900" data-id="element-948">
              Trainingsmateriaal
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-949">Bekijk documenten</p>
          </div>
        </Card>
        <Card className="col-span-1 p-4 hover:shadow-md transition-shadow cursor-pointer" data-id="element-950">
          <div className="flex flex-col items-center text-center" data-id="element-951">
            <div className="p-3 rounded-full bg-purple-100 mb-3" data-id="element-952">
              <MessageSquareIcon className="h-6 w-6 text-purple-600" data-id="element-953" />
            </div>
            <h3 className="text-sm font-medium text-gray-900" data-id="element-954">
              Contact Planner
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-955">Stel een vraag</p>
          </div>
        </Card>
        <Card className="col-span-1 p-4 hover:shadow-md transition-shadow cursor-pointer" data-id="element-956">
          <div className="flex flex-col items-center text-center" data-id="element-957">
            <div className="p-3 rounded-full bg-red-100 mb-3" data-id="element-958">
              <AlertTriangleIcon className="h-6 w-6 text-red-600" data-id="element-959" />
            </div>
            <h3 className="text-sm font-medium text-gray-900" data-id="element-960">Ziek Melden</h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-961">Niet beschikbaar</p>
          </div>
        </Card>
      </div>
    </div>;
}
// Helper component for save icon (not imported from lucide-react)
function SaveIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-962">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" data-id="element-963"></path>
      <polyline points="17 21 17 13 7 13 7 21" data-id="element-964"></polyline>
      <polyline points="7 3 7 8 15 8" data-id="element-965"></polyline>
    </svg>;
}